export interface PreparedTenantLogo {
    blob: Blob;
    width: number;
    height: number;
}

export async function prepareTenantLogo(file: File): Promise<PreparedTenantLogo> {
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) throw new Error('tenant.logoFileType');
    if (!file.size || file.size > 5 * 1024 * 1024) throw new Error('tenant.logoFileSize');
    let bitmap: ImageBitmap;
    try {
        bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    } catch (cause) {
        throw new Error('tenant.logoReadError', { cause });
    }
    try {
        if (!bitmap.width || !bitmap.height || bitmap.width * bitmap.height > 16_000_000) throw new Error('tenant.logoDimensions');
        const scale = Math.min(1, 256 / bitmap.width, 256 / bitmap.height);
        const width = Math.max(1, Math.round(bitmap.width * scale));
        const height = Math.max(1, Math.round(bitmap.height * scale));
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d');
        if (!context) throw new Error('tenant.logoReadError');
        context.drawImage(bitmap, 0, 0, width, height);
        const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/png'));
        if (!blob || blob.size > 512 * 1024) throw new Error('tenant.logoReadError');
        return { blob, width, height };
    } finally {
        bitmap.close();
    }
}
